








import Vue from 'vue'
import BankAccountForm from '@/components/molecules/PartnerBankAccounts/BankAccountForm.vue'
import {
  CreatePartnerBankAccountInput,
  Mutation,
} from '@/types/generated/graphql'
import MUTATION_CREATE from '@/graphql/partner/createPartnerBankAccount.gql'

type Data = {
  bankAccount: CreatePartnerBankAccountInput
}

type Methods = {
  onClickSave: (bankAccount: CreatePartnerBankAccountInput) => void
  onClickBack: () => void
}
type Props = {
  partnerId: string
  storeId: string | undefined
}

export default Vue.extend<{}, Methods, {}, Props>({
  name: 'BankAccountCreate',
  components: {
    BankAccountForm,
  },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
    storeId: {
      type: String,
    },
  },
  data() {
    return {
      bankAccount: {
        partnerId: this.partnerId,
        storeId: this.storeId,
        bankName: '',
        branchNumber: '',
        branchName: '',
        accountNumber: '',
        accountName: '',
        accountType: undefined,
      },
    }
  },
  methods: {
    async onClickSave(bankAccount: CreatePartnerBankAccountInput) {
      await this.$apollo.mutate<Mutation>({
        mutation: MUTATION_CREATE,
        variables: {
          input: {
            ...bankAccount,
          },
        },
      })
      this.$router.back()
    },
    onClickBack() {
      this.$router.back()
    },
  },
})
